import React, { Component } from 'react';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import A11yFontIcon from 'components/A11yFontIcon';
import './EmojiPicker.css';

class EmojiPicker extends Component {
  componentDidMount() {
    document.body.addEventListener('click', this.handleOutsideClick);
    document.body.addEventListener('scroll', this.handleOutsideClick, true);
    document.body.addEventListener('keydown', this.handleEnterClose, true);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleOutsideClick);
    document.body.removeEventListener('scroll', this.handleOutsideClick, true);
    document.body.removeEventListener('keydown', this.handleEnterClose, true);
  }

  handleOutsideClick = event => {
    const parent = document.querySelector('.emoji-mart');
    if (
      this.props.showEmojiPicker &&
      parent &&
      !parent.contains(event.target)
    ) {
      this.props.onEmojiPickerToggle();
    }
  };

  handleEnterClose = event => {
    if (this.props.showEmojiPicker && event.key === 'Enter')
      this.props.onEmojiPickerToggle();
  };

  render() {
    const { showEmojiPicker, addEmoji, onEmojiPickerToggle } = this.props;

    const popover = (
      <Popover id="emoji-picker-popover">
        <Picker set="emojione" onSelect={addEmoji} showPreview={false} />
      </Popover>
    );

    return (
      <React.Fragment>
        <OverlayTrigger
          show={showEmojiPicker}
          placement="bottom"
          overlay={popover}
          rootClose
          onHide={onEmojiPickerToggle}
          trigger="click"
          flip
        >
          <button
            type="button"
            className="toggle-emoji"
            onClick={onEmojiPickerToggle}
          >
            <A11yFontIcon icon="smile-o" alt="Toggle Emoji Picker" />
          </button>
        </OverlayTrigger>
      </React.Fragment>
    );
  }
}

EmojiPicker.propTypes = {
  showEmojiPicker: PropTypes.bool.isRequired,
  onEmojiPickerToggle: PropTypes.func.isRequired,
  addEmoji: PropTypes.func.isRequired
};

export default EmojiPicker;
